import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import config from "../config.json";

export default class Notification extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  state = {
    isEditMode: false,
    updatedNotification: {
      id: "",
      notificationName: "",
      notificationTitle_da: "",
      notificationTitle_en: "",
      notificationMessage_da: "",
      notificationMessage_en: "",
      notificationImage: "",
      notificationLink: "",
      notificationLinkText_da: "",
      notificationLinkText_en: "",
    },
  };

  componentDidMount() {
    this.setState({ updatedNotification: this.props.notification });
  }

  handleNotificationEdit = (event) => {
    event.preventDefault();
    this.setState({ isEditMode: !this.state.isEditMode });
  };

  handleEditSave = (event) => {
    event.preventDefault();
    this.setState({ isEditMode: false });
    this.props.handleUpdateNotification(this.state.updatedNotification);
  };

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      updatedNotification: {
        ...this.state.updatedNotification,
        [name]: value,
      },
    });
  };

  render() {
    return (
      <div className="tile is-child box notification">
        <Fragment>
          <a
            href="/"
            onClick={this.handleNotificationEdit}
            className="product-edit-icon"
          >
            <FontAwesomeIcon icon="edit" />
          </a>
          <button
            onClick={(event) =>
              this.props.handleDeleteNotification(
                this.props.notification.id,
                event
              )
            }
            className="delete"
          ></button>
        </Fragment>

        {this.state.isEditMode ? (
          <div>
            <p className="product-id">id: {this.props.notification.id}</p>

            <p>Billede</p>
            <select
              name="notificationImage"
              value={this.state.updatedNotification.notificationImage}
              onChange={this.handleInputChange}
            >
              <option value=""></option>
              {this.props.notificationImages.map((notificationImage) => {
                return (
                  <option
                    key={notificationImage.Key}
                    value={notificationImage.Key}
                  >
                    {notificationImage.Key}
                  </option>
                );
              })}
            </select>
            <p>Navn</p>
            <input
              className="input is-medium"
              type="text"
              value={this.state.updatedNotification.notificationName}
              onChange={this.handleInputChange}
              name={"notificationName"}
            />

            <p>Titel dansk</p>
            <input
              className="input is-medium"
              type="text"
              value={this.state.updatedNotification.notificationTitle_da}
              onChange={this.handleInputChange}
              name={"notificationTitle_da"}
            />
            <p>Titel engelsk</p>
            <input
              className="input is-medium"
              type="text"
              value={this.state.updatedNotification.notificationTitle_en}
              onChange={this.handleInputChange}
              name={"notificationTitle_en"}
            />

            <textarea
              className="textarea"
              placeholder="Indtast besked (DANSK)"
              name="notificationMessage_da"
              value={this.state.updatedNotification.notificationMessage_da}
              onChange={this.handleInputChange}
            />
            <textarea
              className="textarea"
              placeholder="Indtast besked (ENGELSK)"
              name="notificationMessage_en"
              value={this.state.updatedNotification.notificationMessage_en}
              onChange={this.handleInputChange}
            />

            <p>Link URL</p>
            <input
              className="input is-medium"
              type="text"
              value={this.state.updatedNotification.notificationLink}
              onChange={this.handleInputChange}
              name="notificationLink"
            />

            <p>Link tekst (dansk)</p>
            <input
              className="input is-medium"
              type="text"
              value={this.state.updatedNotification.notificationLinkText_da}
              onChange={this.handleInputChange}
              name="notificationLinkText_da"
            />

            <p>Link tekst (engelsk)</p>
            <input
              className="input is-medium"
              type="text"
              value={this.state.updatedNotification.notificationLinkText_en}
              onChange={this.handleInputChange}
              name="notificationLinkText_en"
            />

            <button
              type="submit"
              className="button is-info is-small"
              onClick={this.handleEditSave}
            >
              Gem
            </button>
          </div>
        ) : (
          <div>
            {this.state.updatedNotification.notificationImage && (
              <img
                className="organization-image"
                src={`${
                  config.s3.notificationImagesUrl +
                  this.state.updatedNotification.notificationImage
                }`}
              />
            )}
            <p className="product-title">
              {this.props.notification.notificationName}
            </p>
            <p className="product-id">
              <b>Titel (dansk):</b>{" "}
              {this.props.notification.notificationTitle_da}
            </p>
            <p className="product-id">
              <b>Titel (engelsk):</b>{" "}
              {this.props.notification.notificationTitle_en}
            </p>
            <p className="product-id">
              <b>Besked (dansk):</b>{" "}
              {this.props.notification.notificationMessage_da}
            </p>
            <p className="product-id">
              <b>Besked (engelsk):</b>{" "}
              {this.props.notification.notificationMessage_en}
            </p>
            {this.props.notification.notificationLink && (
              <p className="product-id">
                <b>Link URL:</b>{" "}
                <a
                  href={this.props.notification.notificationLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {this.props.notification.notificationLink}
                </a>
              </p>
            )}
            {this.props.notification.notificationLinkText_da && (
              <p className="product-id">
                <b>Link tekst (dansk):</b>{" "}
                {this.props.notification.notificationLinkText_da}
              </p>
            )}
            {this.props.notification.notificationLinkText_en && (
              <p className="product-id">
                <b>Link tekst (engelsk):</b>{" "}
                {this.props.notification.notificationLinkText_en}
              </p>
            )}
          </div>
        )}
      </div>
    );
  }
}
